import { useGetTaskBasesQuery } from "./taskBasesApiSlice"
import TaskBase from "./TaskBase"
import useAuth from "../../hooks/useAuth"
import PulseLoader from 'react-spinners/PulseLoader'
import { faAdd } from "@fortawesome/free-solid-svg-icons"
import { Link, useParams } from "react-router-dom"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
const TaskBasesList = ({course, q, selected, setSelected}) => {
    const {groupId, type} = useParams()
    const {  isTeacher, isAdmin } = useAuth()
    const {
        data: taskBases,
        isLoading,
        isSuccess,
        isError,
        error
    } = useGetTaskBasesQuery('taskBasesList', {
        // pollingInterval: 15000,
        // refetchOnFocus: true,
        refetchOnMountOrArgChange: false
    })




    let content

    if (isLoading) content = <PulseLoader color={"#FFF"} />

    if (isError) {
        content = <p className="errmsg">{error?.data?.message}</p>
    }
    if (isSuccess ) {
        let filteredTasksBases = [...taskBases]
        if(course && course.length || q!=='' && q.length){
            filteredTasksBases=filteredTasksBases.filter(taskBase =>{
             return ((!course ||course ==='' || taskBase.course._id === course ) &&
                     (q==='' ||((taskBase.title.toLowerCase().indexOf(q.toLowerCase()) >-1)||(taskBase.body.toLowerCase().indexOf(q.toLowerCase()) >-1) )))

            })
        }

        let addButtn= null
        if(isAdmin ){
        addButtn = (
        <Link to={`/${type}/${groupId}/task-bases/new`}>
 <FontAwesomeIcon icon={faAdd} />הוספת משימה
        </Link>
        
      )
        }

        const tableContent = filteredTasksBases.map(taskBase => <TaskBase selected={selected} key={taskBase._id} taskBase={taskBase} setSelected={setSelected} />)

        content = (
            <>
            {addButtn}
            <table className={`table table--task-bases `}>
                <thead className="table__thead">
                    <tr>
                        <th scope="col" className="table__th taskBase__title">קורס</th>
                        <th scope="col" className="table__th taskBase__title">משימה</th>
                        <th scope="col" className="table__th "> מיון</th>
                        <th scope="col" className="table__th "> יחס</th>
                        <th scope="col" className="table__th taskBase__actions"> פעולות</th>
                        <th scope="col" className="table__th taskBase__edit">#</th>
                    </tr>
                </thead>
                <tbody>
                    {tableContent}
                </tbody>
            </table>
            </>
        )
    }

    return content
}
export default TaskBasesList